var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Cadastro ")])])])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "nome",
      "label-for": "responsavel",
      "label": "Nome/Razão Social"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('nome'),
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.nome.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.nome, "$model", $$v);
      },
      expression: "$v.form.nome.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cnpj_cpf",
      "label": "CPF/CNPJ",
      "label-for": "cnpj_cpf"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "cnpj_cpf",
      "name": "cnpj_cpf",
      "state": _vm.validateState('cnpj_cpf')
    },
    nativeOn: {
      "input": function input($event) {
        return _vm.onCpfCnpjInput($event, _vm.form, 'cnpj_cpf');
      }
    },
    model: {
      value: _vm.$v.form.cnpj_cpf.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.cnpj_cpf, "$model", $$v);
      },
      expression: "$v.form.cnpj_cpf.$model"
    }
  })], 1)], 1)], 1), _c('b-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.cnpj_cpf,
      expression: "form.cnpj_cpf"
    }]
  }, [_c('b-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.juridica,
      expression: "juridica"
    }],
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "nome_fantasia",
      "label": "Nome Fantasia",
      "label-for": "nome_fantasia"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nome_fantasia",
      "name": "nome_fantasia",
      "placeholder": ""
    },
    model: {
      value: _vm.form.nome_fantasia,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nome_fantasia", $$v);
      },
      expression: "form.nome_fantasia"
    }
  })], 1)], 1), _c('b-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.juridica,
      expression: "juridica"
    }],
    attrs: {
      "md": "3"
    }
  }, [[_c('b-form-group', {
    attrs: {
      "id": "inscricao_municipal",
      "label": "Insc. Municípal",
      "label-for": "inscricao_municipal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "inscricao_municipal",
      "name": "inscricao_municipal",
      "placeholder": ""
    },
    model: {
      value: _vm.form.inscricao_municipal,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "inscricao_municipal", $$v);
      },
      expression: "form.inscricao_municipal"
    }
  })], 1)]], 2), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "ie_rg",
      "label": "IE/RG",
      "label-for": "ie_rg"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "ie_rg",
      "name": "ie_rg",
      "state": _vm.validateState('ie_rg')
    },
    model: {
      value: _vm.form.ie_rg,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ie_rg", $$v);
      },
      expression: "form.ie_rg"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "responsavel",
      "label": "Responsável",
      "label-for": "responsavel"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "responsavel",
      "name": "responsavel",
      "placeholder": "",
      "state": _vm.validateState('responsavel')
    },
    model: {
      value: _vm.form.responsavel,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "responsavel", $$v);
      },
      expression: "form.responsavel"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "telefone",
      "label": "Telefone",
      "label-for": "example-input-0"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['(##) #### ####', '(##) # #### ####'],
      expression: "['(##) #### ####', '(##) # #### ####']"
    }],
    attrs: {
      "state": _vm.validateState('fone'),
      "aria-describedby": "input-0-live-feedback"
    },
    model: {
      value: _vm.$v.form.fone.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.fone, "$model", $$v);
      },
      expression: "$v.form.fone.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "email",
      "label": "E-mail",
      "label-for": "example-input-0"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('email'),
      "aria-describedby": "input-0-live-feedback"
    },
    model: {
      value: _vm.$v.form.email.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.email, "$model", $$v);
      },
      expression: "$v.form.email.$model"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CEP",
      "label-for": "form.cep"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['#####-###'],
      expression: "['#####-###']"
    }],
    ref: "cep",
    attrs: {
      "id": "form.cep",
      "name": "form.cep",
      "aria-describedby": "form.cep",
      "state": _vm.validateState('cep')
    },
    on: {
      "change": _vm.consultaCep
    },
    model: {
      value: _vm.form.cep,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cep", $$v);
      },
      expression: "form.cep"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número",
      "label-for": "form.numero"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "form.numero",
      "name": "form.numero",
      "aria-describedby": "form.numero",
      "state": _vm.validateState('numero')
    },
    model: {
      value: _vm.form.numero,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "numero", $$v);
      },
      expression: "form.numero"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bairro",
      "label-for": "form.bairro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "form.bairro",
      "name": "form.bairro",
      "aria-describedby": "form.bairro",
      "state": _vm.validateState('bairro')
    },
    model: {
      value: _vm.form.bairro,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bairro", $$v);
      },
      expression: "form.bairro"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Logradouro",
      "label-for": "form.logradouro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "form.logradouro",
      "name": "form.logradouro",
      "aria-describedby": "form.logradouro",
      "state": _vm.validateState('logradouro')
    },
    model: {
      value: _vm.form.logradouro,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "logradouro", $$v);
      },
      expression: "form.logradouro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Complemento",
      "label-for": "form.complemento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "form.complemento",
      "name": "form.complemento",
      "aria-describedby": "form.complemento"
    },
    model: {
      value: _vm.form.complemento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "complemento", $$v);
      },
      expression: "form.complemento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cidade",
      "label-for": "form.cidade"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "cidade",
      "options": _vm.cidades
    },
    on: {
      "input": _vm.setCidade,
      "search": _vm.onSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")])];
      }
    }]),
    model: {
      value: _vm.cidade,
      callback: function callback($$v) {
        _vm.cidade = $$v;
      },
      expression: "cidade"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome da cidade ")])], 2)], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_emitente",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'revendasLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };